function calculateToggleMargin() {
  const toggle = document.getElementById('hh-toggle')
  if (toggle) {
    const leftMargin = Math.round(toggle.getBoundingClientRect().left) + 10
    document.documentElement.style.setProperty('--toggle-left-margin', `${leftMargin}px`)
  }
}

document.addEventListener('DOMContentLoaded', calculateToggleMargin)
window.addEventListener('load', calculateToggleMargin)
window.addEventListener('resize', calculateToggleMargin)
